import { t } from 'i18next';

export enum CallSiteStatus {
  COVERED = 'COVERED',
  MISSED = 'MISSED',
  NOT_COVERED = 'NOT_COVERED',
}

export const getCallSiteStatus = (covered: boolean | null): string => {
  switch (covered) {
    case true:
      return t('covered');
    case false:
      return t('notCovered');
    default:
      return t('missed');
  }
};
